import React from 'react'
import { Badge, Space, Tag, Typography } from 'antd'

const { Text } = Typography

// Format priority as a colored tag
export const getPriorityTag = (priority) => {
  let color = 'blue'
  if (priority === 'High') color = 'orange'
  if (priority === 'Critical') color = 'red'
  if (priority === 'Low') color = 'green'

  return <Tag color={color}>{priority}</Tag>
}

// Get due status badge based on due date
export const getDueStatusBadge = (dueDate) => {
  const now = new Date()
  const due = new Date(dueDate)
  const diffHours = Math.round((due - now) / (1000 * 60 * 60))

  if (diffHours < 0) {
    return <Badge status='error' text='Overdue' />
  } else if (diffHours < 2) {
    return <Badge status='warning' text='Due Soon' />
  } else {
    return <Badge status='success' text='On Schedule' />
  }
}

// Format date and time
export const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return '-'
  return new Date(dateTimeString).toLocaleString()
}

// Format patient information with name and ID
export const formatPatientInfo = (name, id) => (
  <Space direction='vertical' size={0}>
    <Text>{name}</Text>
    <Text type='secondary' style={{ fontSize: '12px' }}>
      {id}
    </Text>
  </Space>
)

// Format due date with status badge
export const formatDueDate = (date, isCompleted = false) => (
  <Space direction='vertical' size={0}>
    <Text>{formatDateTime(date)}</Text>
    {!isCompleted && <div>{getDueStatusBadge(date)}</div>}
  </Space>
)
